import { Component, OnInit, Inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth'
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { OrderDialogComponent } from '../order-dialog/order-dialog.component';
import { userInfo } from 'os';
import { AngularFireFunctions } from '@angular/fire/functions/';
import { AngularFirestore } from '@angular/fire/firestore';
@Component({
  selector: 'app-new-password-dialog',
  templateUrl: './new-password-dialog.component.html',
  styleUrls: ['./new-password-dialog.component.scss']
})
export class NewPasswordDialogComponent implements OnInit {
  hide = true;
  constructor(
    public dialogRef: MatDialogRef<NewPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private auth: AngularFireAuth,
    private router: Router,
    private _snackBar: MatSnackBar,
    private func: AngularFireFunctions,
    private firestore: AngularFirestore
  ) {
    
  }

  resetPassword(newPassword) {
    if (newPassword.length < 6) {
      this.openSnackBar("Minimalna dužina lozinke je 6 karaktera", "Ok")
      return;
    }
    this.auth.confirmPasswordReset(this.data.oobCode, newPassword)
      .then((d) => {
        this.auth.signInWithEmailAndPassword(this.data.email, newPassword)
          .then(async (userInfo) => {
            this.dialogRef.close(200)
            this.firestore.doc(`users/${userInfo.user.uid}`).get()
              .subscribe(async (user) => {
                if (!user.data().isVerified) {
                  await this.firestore.doc(`users/${userInfo.user.uid}`).update({ isVerified: true })
                  user.ref.collection('orders').get()
                    .then((orders) => {
                      console.log(orders)
                      if (orders.docs.length > 0) {
                        this.func.httpsCallable('sendOrderRecievedEmail')({
                          order_id:orders.docs[0].id,
                          uid:userInfo.user.uid
                        })
                          .subscribe((res) => {

                          })
                      }
                    })
                    .catch(err=>{
                      console.log(err)
                    })
                }
              }, err=>{console.log(err)})
          })
      })
      .catch((err) => {
        console.log(err)
      })
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  ngOnInit(): void {
  }

}
